import React, { useState, useRef, useEffect, useCallback } from "react";

const C = {
  gold: "#C9A84C",
  bg: "#1a1a1a",
  border: "#C9A84C",
  text: "#F2F6FA",
};

export default function Tooltip({ text, width = 280, children }) {
  const [open, setOpen] = useState(false);
  const [above, setAbove] = useState(true);
  const trigRef = useRef(null);

  const reposition = useCallback(() => {
    if (!trigRef.current) return;
    const r = trigRef.current.getBoundingClientRect();
    setAbove(r.top > 160);
  }, []);

  useEffect(() => {
    if (open) reposition();
  }, [open, reposition]);

  return (
    <span
      ref={trigRef}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      style={{ position: "relative", display: "inline-flex", alignItems: "center", cursor: "help" }}
    >
      {children || (
        <span style={{ fontSize: 13, color: C.gold, fontWeight: 600, marginLeft: 4, userSelect: "none" }}>
          &#9432;
        </span>
      )}
      {open && (
        <span
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            ...(above ? { bottom: "calc(100% + 8px)" } : { top: "calc(100% + 8px)" }),
            width,
            maxWidth: "90vw",
            background: C.bg,
            border: `1px solid ${C.border}`,
            borderRadius: 8,
            padding: "10px 14px",
            color: C.text,
            fontSize: 12,
            lineHeight: 1.55,
            fontFamily: "'Inter', sans-serif",
            fontWeight: 400,
            fontStyle: "normal",
            textTransform: "none",
            letterSpacing: "0.01em",
            zIndex: 100,
            pointerEvents: "none",
            whiteSpace: "normal",
            boxShadow: "0 4px 16px rgba(0,0,0,0.5)",
          }}
        >
          {text}
        </span>
      )}
    </span>
  );
}
